import { ThemeIcon } from "@mantine/core";
import {
	IconBuilding,
	IconDeviceDesktop,
	IconKey,
	IconLicense,
	IconMail,
	IconUser,
} from "@tabler/icons-react";

import { CATEGORY_LABELS } from "../../utils/activity";

import type { ActivityCategory } from "../../services/api";

const CATEGORY_ICONS = {
	license: IconLicense,
	station: IconDeviceDesktop,
	account: IconBuilding,
	user: IconUser,
	auth: IconKey,
	report: IconMail,
} satisfies Record<ActivityCategory, unknown>;

interface ActivityCategoryIconProps {
	category: ActivityCategory;
}

function ActivityCategoryIcon({ category }: ActivityCategoryIconProps) {
	const CategoryIcon = CATEGORY_ICONS[category];
	return (
		<ThemeIcon
			variant="light"
			size="md"
			radius="xl"
			title={CATEGORY_LABELS[category]}>
			<CategoryIcon size={16} />
		</ThemeIcon>
	);
}

export default ActivityCategoryIcon;
